export default __webpack_public_path__ + "src/_images/Copilot_Icon.svg";